// Constants for different requests for current reducer
export default {
  sites: 'SITES',
  addSite: 'ADD_SITE',
};
